import ModelMarshaller from './ModelMarshaller';
import Article from './Article';
import PriceItemMashaller from './PriceItemMarshaller';
import PriceItem from './PriceItem';
import User from "@/logic/model/User";

export default class ArticleMarshaller extends ModelMarshaller<User> {
   
    
    toJSON() {
        if (this.data instanceof User) {

            return {
                name: this.data.$name,
                id: this.data.$id,
                send_mails: this.data.$sendMails,
                is_admin: this.data.$isAdmin
            }
        }
        return this.data
    }    
    
    toModel(): User {
        if (this.data instanceof User) {
            return this.data
        }
        let user = new User(this.data.name,this.data.id,Boolean(this.data.is_admin),Boolean(this.data.send_mails));

        return user;
    }


}